import type { UploadTask } from '../types/uploads';

interface LocalUploadIdentity {
  contentBlake3: string;
  mediaType: 'video' | 'mcap';
  projectId: string;
  size: number;
}

/** Content is the primary identity, while destination, media contract and byte length prevent an
 * existing session from being adopted outside the exact upload context it was created for. */
export function localUploadIdentityKey(identity: LocalUploadIdentity): string {
  return JSON.stringify([
    identity.projectId,
    identity.mediaType,
    identity.size,
    identity.contentBlake3,
  ]);
}

export function uploadTaskIdentityKey(item: UploadTask): string | undefined {
  if (item.channel !== 'upload' || !item.contentBlake3) return undefined;
  return localUploadIdentityKey({
    projectId: item.target.projectId,
    mediaType: item.mediaType ?? 'video',
    size: item.totalBytes,
    contentBlake3: item.contentBlake3,
  });
}

export function indexLocalUploadTasks(items: readonly UploadTask[]): Map<string, string[]> {
  const result = new Map<string, string[]>();
  for (const item of items) {
    const key = uploadTaskIdentityKey(item);
    if (!key) continue;
    const ids = result.get(key);
    if (ids) ids.push(item.id);
    else result.set(key, [item.id]);
  }
  return result;
}

export function addLocalUploadTaskToIndex(
  index: Map<string, string[]>,
  key: string,
  uploadTaskId: string,
): void {
  const ids = index.get(key);
  if (ids) {
    if (!ids.includes(uploadTaskId)) ids.push(uploadTaskId);
  } else {
    index.set(key, [uploadTaskId]);
  }
}
